import React from "react";
import { Box } from "@mui/material";

import { NumericFormat } from "react-number-format";
import RenderDate from "../../../Common/Date/RenderDate";
import RenderPerson from "../../../Common/Person/RenderPerson";

const JobPlanDetails = ({ jobPlan = {}, isActive = false }) => {
    const person = jobPlan.worker;
    const activityCount = jobPlan?.activities?.length || 0
    const objectiveCount = jobPlan.objectives?.length || 0;
    const displayJobRole = person?.jobRole || "Not specified";
    const displayMainPlaceOfWork = jobPlan?.mainPlaceOfWork?.name || "Not specified";
    const displayAreaOfWork = jobPlan?.speciality?.name || "Not specified";
    const displayOrganisation = jobPlan?.organisation?.name || "Not specified";

    const contractedDurationWeeklyAverage = jobPlan.activities?.reduce((acc, activity) => (
        (!['PA', 'APA'].includes(activity.type?.code) || !activity.type.contracted)
            ? acc
            : {
                ...acc,
                [activity.type.code]: acc[activity.type.code] + activity.durationNormal + activity.durationPremium
            }
    ), { PA: 0, APA: 0 });

    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Name</dt>
                <dd>
                    <RenderPerson person={person} isRequired={isActive} />
                </dd>
            </dl>

            <dl className="row-data">
                <dt>Job role</dt>
                <dd>{displayJobRole}</dd>
            </dl>

            <dl className="row-data">
                <dt>Area of work</dt>
                <dd>{displayAreaOfWork}</dd>
            </dl>

            <dl className="row-data">
                <dt>Organisation</dt>
                <dd>{displayOrganisation}</dd>
            </dl>

            <dl className="row-data">
                <dt>Main place of work</dt>
                <dd>{displayMainPlaceOfWork}</dd>
            </dl>

            <dl className="row-data">
                <dt>Contract type</dt>
                <dd>{jobPlan?.contractType || ""}</dd>
            </dl>

            <dl className="row-data">
                <dt>Staff group</dt>
                <dd>{jobPlan?.staffGroup || ""}</dd>
            </dl>

            <dl className="row-data">
                <dt>Working weeks</dt>
                <dd>{jobPlan?.workingWeeks || ""}</dd>
            </dl>

            <dl className="row-data">
                <dt>Contracted hours</dt>
                <dd>{jobPlan?.contractedHours}</dd>
            </dl>

            <dl className="row-data">
                <dt>Activities</dt>
                <dd>{activityCount}</dd>
            </dl>

            <dl className="row-data">
                <dt>Objectives</dt>
                <dd>{objectiveCount}</dd>
            </dl>

            <dl className="row-data">
                <dt>PA / APA</dt>
                <dd>
                    {" "}
                    <NumericFormat
                        value={contractedDurationWeeklyAverage?.PA}
                        decimalSeparator="."
                        displayType="text"
                        decimalScale={3}
                    />{" "}
                    /&nbsp;
                    <NumericFormat
                        value={contractedDurationWeeklyAverage?.APA}
                        decimalSeparator="."
                        displayType="text"
                        decimalScale={3}
                    />
                </dd>
            </dl>

            <dl className="row-data">
                <dt>Effective date</dt>
                <dd>
                    {!!jobPlan?.effectiveDate && <RenderDate date={jobPlan.effectiveDate} />}
                </dd>
            </dl>
        </Box>
    );
};

export default React.memo(JobPlanDetails);
